<!--

A simple helper for displaying text addresses. Includes "place" icon, which
you can style. 5 lines available. Defaults to blue. optional phone and email

Example Usage

<address-simple
line1="301 Market Street"
line2="Steubenville, OH 43952"
line3="Room 300"
></address-simple>

-->

<template>
  <div class="row addr">
    <div class="col">
      
      <div class="row">
        <div class="col-xs-1 icon-width">
          <i class="material-icons">place</i>
        </div>

        <div class="col-xs-11">  
          <ul>
            <li v-for="(line,index) in addressLines">
              <div>
              {{line}}
              </div>
            </li>
          </ul>
        </div>
      </div>

      <template v-if="phone">
        <div class="row mt-3">
          <div class="col-xs-1 icon-width">
            <i class="material-icons">call</i>
          </div>

          <div class="col-xs-11">  
            <ul>
              <li>
                {{phone}}
              </li>
            </ul>
          </div>
        </div>
      </template>

      <template v-if="email">
        <div class="row">
          <div class="col-1 icon-width">
            <i class="material-icons">email</i> 
          </div>
          <div class="col-11 email">
            <a :href="`mailto:${this.email}`" class="text-primary text-light-blue-9">{{email}}</a>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>

export default {
  components: {},

  data () {
    return {
      addressLines: []
    }
  },
  props: ['line1','line2','line3','line4','line5','phone','email','fax'],
  created: function () {
    this.makeAddressLines()
  },
  methods: {
    makeAddressLines: function() {
      if (this.line1 != null)
      {
        this.addressLines.push(this.line1)
      }

      if (this.line2 != null)
      {
        this.addressLines.push(this.line2)
      }

      if (this.line3 != null)
      {
        this.addressLines.push(this.line3)
      }

      if (this.line4 != null)
      {
        this.addressLines.push(this.line4)
      }

      if (this.line5 != null)
      {
        this.addressLines.push(this.line5)
      }
    }
  }
}
</script>

<style scoped>

.icon-indent {
  margin: 0 0 0 20px;
}

.addr {
  width: 100%;
}

.icon-width {
  max-width: 16px;
  margin-right: 10px;
}

.addr ul {
  padding: 0;
  margin: 0;
}
.addr li {
  list-style-type: none;
}

.phone {
  font-weight: bold;
  margin: 1.0em 0 0 0;
}

.email a:hover {
  text-decoration: underline;
}

</style>
